import { h } from 'preact';
import {
  Modal,
  ModalBody,
  ModalButton,
  ModalContext,
  ModalFooter,
  ModalHeader,
  ModalProps,
  ModalTitle,
} from '../../../modal';
import { withStyles, WithStyles } from '../../../style';
import { FinText } from '../../../i18n';

export interface PaxAmountModalBaseProps extends ModalProps {
  enableCompactWidget: boolean;
}

type EffectiveProps = PaxAmountModalBaseProps & WithStyles;

export const PaxAmountModalBase = withStyles()((props: PaxAmountModalBaseProps, { modal }: ModalContext) => {
  const { enableCompactWidget, children, ...modalProps } = props as EffectiveProps;

  const closeModal = () => {
    const { onClose } = props;

    if (onClose) {
      onClose();
    }

    modal.hideModal();
  };

  return (
    <Modal {...modalProps}>
      <ModalHeader>
        <ModalTitle onClose={closeModal}>
          <FinText id={enableCompactWidget ? 'paxAndClassSelector.label' : 'paxAmountModal.title'} />
        </ModalTitle>
      </ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter sticky>
        <ModalButton onClick={closeModal} cta>
          <FinText id="action.done" />
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
});
